import { styled } from "goober";
import { ClickButton } from "./ClickButton";

export const WorkflowNavigationButton = styled(ClickButton)`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  height: 32px;
  padding: 8px;
  border-radius: 8px;

  &:hover,
  &:focus-visible,
  [data-dropdown-open="true"] & {
    background: var(--alpha4);
  }
`;
